const mapTypeFilled = {
  type: "svg",
  props: {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  },
  metadata: {
    description: "Represents different base map styles used within map applications.",
    usage: "May show ability to switch the base map style. Can also represent map layers.",
    category: "Maps",
    tags: ["maps", "layer", "base", "map style", "type", "fill"]
  },
  children: [{
    type: "path",
    props: {
      d: "M11.39 16.52a1 1 0 001.22 0l6.75-5.25.62-.48a1 1 0 000-1.58l-7.37-5.73a1 1 0 00-1.22 0L4 9.2a1 1 0 000 1.58l.62.48 6.76 5.25zm.61 3.02l-7.38-5.73-.6.47a1 1 0 000 1.58l7.37 5.73a1 1 0 001.22 0L20 15.86a1 1 0 000-1.58l-.62-.48L12 19.54z"
    }
  }]
};
export default mapTypeFilled;